import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .PartnershipAccountPage__caption {
    margin-bottom: 15px;
  }

  .PartnershipAccountPage__table {
    :global(.NoItemsPanel) {
      height: rem(250px);
      min-height: auto;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
      :global(img) {
        margin-bottom: rem(20px);
        width: 230px;
        height: 100px;
      }
    }

    :global(.PartnerAccountInfoTable) {
      :global(.ReactDataTable__wrapper) {
        width: 100%;

        :global(.ReactDataTable) {
          :global(.ReactDataTable__tbody-cell:nth-child(3) span) {
            font-size: rem(15px) !important;
          }
          :global(.ReactDataTable__tbody-cell:nth-child(5) span) {
            font-size: 15px;
          }
        }
      }

      :global(.account) {
        font-size: rem(16px);
      }
      :global(.MoneyCell__inner) {
        height: auto;
      }
    }
  }
`;

const getDynamicStyles = ({ colors, border }) => {
  return css`
    .PartnershipAccountPage__table {
      :global(.NoItemsPanel) {
        background: ${colors.white.hex};
        border-radius: ${border.radius};
      }

      :global(.PartnerAccountInfoTable) {
        :global(.account) {
          color: ${colors.secondary.hex};
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
